import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { usePusherChannel, ConnectionState } from './use-pusher-channel';
import { PusherConnectionStatus } from './pusher-connection-status';
import { MinimumConnectedClientsNotification } from './minimum-connected-clients-notification';

export function PusherConnection({
  children,
  eventHandlers,
  config,
  statusClassName,
  minimumClients,
  minimumClientsMessage,
}) {
  const { connectionStatus, channel } = usePusherChannel(config);

  useEffect(() => {
    const eventNames = Object.keys(eventHandlers);

    if (channel && eventNames.length) {
      eventNames.forEach((eventName) => {
        const cb = eventHandlers[eventName];
        channel.bind(eventName, (event) => cb(event));
      });
    }

    return () => {
      eventNames.forEach((eventName) => {
        const cb = eventHandlers[eventName];
        channel?.unbind(eventName, cb);
      });
    };
  }, [eventHandlers.keys, channel]);

  return (
    <div className="pusher-connection h-100 d-flex flex-column">
      {connectionStatus === ConnectionState.CONNECTED && children}
      {Boolean(minimumClients) && (
        <MinimumConnectedClientsNotification
          minimumClients={minimumClients}
          connectionStatus={connectionStatus}
          channel={channel}
          statusClassName={statusClassName}
          notificationMessage={minimumClientsMessage}
        />
      )}
      <PusherConnectionStatus
        connectionStatus={connectionStatus}
        statusClassName={statusClassName}
      />
    </div>
  );
}

PusherConnection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  eventHandlers: PropTypes.objectOf(PropTypes.func),
  config: PropTypes.shape({
    key: PropTypes.string.isRequired,
    cluster: PropTypes.string.isRequired,
    channel: PropTypes.string.isRequired,
  }).isRequired,
  statusClassName: PropTypes.string,
  minimumClients: PropTypes.number,
  minimumClientsMessage: PropTypes.string,
};

PusherConnection.defaultProps = {
  eventHandlers: {},
};
